import React, { useContext } from 'react';
import { Container } from '@material-ui/core';
import codings from '../../assets/lottie/coding.json';
import { ThemeContext } from '../../contexts/ThemeContext';
import { aboutData } from '../../data/aboutData';
import AnimationLottie from '../Animation';
import './About.css';

function About() {
    const { theme } = useContext(ThemeContext);

    const styles = {
        wrapper: { backgroundColor: theme.secondary },
        primaryBg: { backgroundColor: theme.primary },
        primaryColor: { color: theme.primary },
        tertiaryColor: { color: theme.tertiary }
    };

    return (
        <div style={styles.wrapper}>
            <Container className="about" id="about">

                <div className="line-styling">
                    <div className="style-circle" style={styles.primaryBg}></div>
                    <div className="style-circle" style={styles.primaryBg}></div>
                    <div className="style-line" style={styles.primaryBg}></div>
                </div>
                
                <div className="about-body">
                    <div className="about-description">
                        <h2 style={styles.primaryColor}>{aboutData.title}</h2>
                        <p style={styles.tertiaryColor}>
                            {aboutData.description1}{' '}
                            <strong className="font-bold underline">{aboutData.description2}</strong>{' '}
                            {aboutData.description3}
                            <br /><br />
                            {aboutData.description4}
                        </p>
                    </div>
                    
                    <div className="about-animation">
                        <AnimationLottie animationPath={codings} />
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default About;